module.exports = __webpack_public_path__ + "img/tuzaititlr.8c5a9c7a.png";